import { useEffect, useState, useCallback } from 'react';
import { User } from 'oidc-client-ts';
import { userManager } from 'services/oidcConfig';
import cls from './auth-page.module.scss';

export const AuthPage = () => {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const loadUser = useCallback(async () => {
    try {
      const currentUser = await userManager.getUser();
      setUser(currentUser);
      setError(null);
    } catch (err: any) {
      setError(err?.message || 'Failed to load user');
    } finally {
      setLoading(false);
    }
  }, []);

  const handleLogin = useCallback(async () => {
    try {
      await userManager.signinRedirect({
        extraQueryParams: {
          audience: process.env.REACT_APP_OIDC_AUD ?? 'xovi-ai',
          branding: 'riva',
        },
      });
    } catch (err: any) {
      setError(err?.message || 'Login failed');
    }
  }, []);

  useEffect(() => {
    loadUser().then(async () => {
      const currentUser = await userManager.getUser();
      if (!currentUser || currentUser.expired) {
        handleLogin();
      }
    });
  }, [loadUser, handleLogin]);

  const isAuthenticated = !!user && !user.expired;
  console.log(loading, isAuthenticated, error);

  return (
    <div className={cls.authPage}>
      <div className={cls.content}>
        <div className={cls.header}>
          <h2>Redirecting to login...</h2>
          <p>Please wait while we connect you to the authentication server.</p>
        </div>
      </div>
      <div className={cls.bg}>
        <div className={cls.blue} />
        <div className={cls.pink} />
        <div className={cls.orange} />
      </div>
    </div>
  );
};
